// extracted by mini-css-extract-plugin
module.exports = {"largeImage":"CoquillageSection-module--largeImage--21dSX","smallImage":"CoquillageSection-module--smallImage--2Hz_1"};